export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Moneda',
	plural_model_name_spanish: 'Monedas',
	create_model_name_spanish: 'Nueva Moneda',
	text_delete: 'la',
}